import React from 'react';
import { inject, observer } from 'mobx-react';
import styles from './index.module.scss';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import { withRouter } from 'react-router-dom';
import { BaseComponent } from '@components/Base/h5/BaseComponent';
import type { BaseRouteComponentProps } from '../../../types/base';
import InfiniteScrollList from '@components/InfiniteScrollList';
import { formatNumberToWan } from '@utils/formatNumber';
import { highlightname } from '@utils/high-light-name';

interface H5TopicListProps extends BaseRouteComponentProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    data: any;
    loading?: boolean;
    hasMore?: boolean;
    onLoadMore?: () => void;
    goTopic?: Function
    topicList?: any // 推荐关注用户列表
    handleFollowToggle?: any  // 取消关注、关注话题
    searchKeyword?: any // 高亮字段
    emptyText?: string; // 为空时提示文字
    emptyIcon?: string; // 为空时icon
    emptyBoxStyle?: any; // 为空状态时的自定义样式
}

@inject('app', 'site', 'user')
@observer
class H5TopicList extends BaseComponent<H5TopicListProps> {
    componentDidMount() {
        // 可以在这里添加初始化逻辑
        console.log('这里是H5');
    }

    
    // // 搜索文字高亮
    // highlightname(text, searchText) {
    //     if (!searchText || !text) return text;
        
    //     const lowerText = text.toLowerCase();
    //     const lowerSearch = searchText.toLowerCase();
    //     const searchIndex = lowerText.indexOf(lowerSearch);
        
    //     if (searchIndex === -1) return text;
        
    //     const beforeMatch = text.substring(0, searchIndex);
    //     const matchedText = text.substring(searchIndex, searchIndex + searchText.length);
    //     const afterMatch = text.substring(searchIndex + searchText.length);
        
    //     return `${beforeMatch}<span style="color:#022DB8">${matchedText}</span>${afterMatch}`;
    // }

    // 渲染单个列表项
    renderUserItem = (item: any, index: number) => {
        const { goTopic, searchKeyword, handleFollowToggle } = this.props;
        return (
            <React.Fragment key={item.id || item._id || index}>
                <div className={styles.item}>
                    <img src={item.avatar} alt="" className={styles.topicAvatar}onClick={() => goTopic && goTopic(item)}/>
                    <div className={styles.info} onClick={() => goTopic && goTopic(item)}>
                        <div 
                            className={styles.name}
                            dangerouslySetInnerHTML={{ 
                                __html: highlightname(item.name, searchKeyword) || '用户名'
                            }}
                            />
                            
                            <div className={styles.detail}>
                                <div className={styles.count}>{formatNumberToWan(item?.threadCount)}帖子</div>
                                <div className={styles.count}>{formatNumberToWan(item?.discussionCount)}讨论量</div>
                            </div>
                            
                    </div>
                    {!item.isFollowed && <div className={styles.userFollow} onClick={(e) => {
                        // console.log('加关注');
                        e.stopPropagation();
                        
                        window.globalEnsureLogin(() => {
                            console.log('加关注1122');
                            handleFollowToggle && handleFollowToggle(item, index)
                        });
                    }}>关注</div>}
                    {item.isFollowed && <div className={styles.userFollowed} onClick={(e) => {
                        console.log('取消关注');
                        e.stopPropagation();
                        window.globalEnsureLogin(() => { 
                            handleFollowToggle && handleFollowToggle(item, index)
                        });
                        
                    }}>已关注</div>}
                </div>
                
            </React.Fragment>
        );
    };

    renderContent() {
        const { topicList, loading = false, hasMore = true, emptyText, emptyIcon, emptyBoxStyle, onLoadMore } = this.props;

        if (!Array.isArray(topicList)) return null;

        return (
            <div className={styles.listBox} style={{background: topicList?.length == 0 ? 'transparent' : ''}}>
                <InfiniteScrollList
                    variant="h5"
                    data={topicList}
                    loading={loading}
                    hasMore={hasMore}
                    onLoadMore={onLoadMore || (() => { })}
                    renderItem={(item, index) => this.renderUserItem(item, index)}
                    threshold={100}
                    emptyText={emptyText || '这里是空的'}
                    emptyIcon={emptyIcon}
                    emptyBoxStyle={emptyBoxStyle}
                    loadingText="加载中..."
                    noMoreText="没有更多话题了"
                />
            </div>
        );
    }
}

export default withRouter(H5TopicList);